import { ParagraphNode as LexicalParagraphNode, LineBreakNode } from 'lexical';

import TextNode from './TextNode';

class ParagraphNode extends LexicalParagraphNode {
  static getType() {
    return 'custom-paragraph';
  }

  static clone(node) {
    return new ParagraphNode(node.__key);
  }

  static importJSON(serializedNode) {
    return super.importJSON(serializedNode);
  }

  static importDOM(domNode) {
    return super.importDOM(domNode);
  }

  isEmpty() {
    const childrenWithoutLineBreaks = this.getChildren().filter(
      (child) => !(child instanceof LineBreakNode)
    );

    if (childrenWithoutLineBreaks.length === 0) {
      return true;
    }

    return childrenWithoutLineBreaks.every(
      (child) =>
        (child instanceof TextNode &&
          this.isTextWithoutSpaces(child?.__text)) ||
        false
    );
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'custom-paragraph',
      direction: 'ltr',
      children: [],
      version: 1,
    };
  }

  exportDOM(editor) {
    const children = this.getChildren();

    // The default output of Lexical is to wrap a <br> to a <p>
    // when children is empty
    if (children.length === 0) {
      return { element: document.createElement('br') };
    }

    const { element } = super.exportDOM(editor);

    // Removes default styles of LexicalJS
    element.removeAttribute('class');
    element.removeAttribute('style');
    element.removeAttribute('dir');

    return { element };
  }

  isTextWithoutSpaces(text) {
    return text.trim().length === 0;
  }
}

export const $addParagraphNodeConfig = (nodes) => {
  nodes.push(ParagraphNode);
  nodes.push({
    replace: LexicalParagraphNode,
    with: () => new ParagraphNode(),
  });
};

export default ParagraphNode;
